<!-- 表单评价详情页面 -->
<template>
    <div class="evaluation-detail-container">
        <!-- 顶部导航栏 -->
        <div class="top-header">
            <div class="header-left">
                <span class="logo-text">互联溯源系统</span>
            </div>
            <div class="header-center">
                <span class="page-title">{{ formName }}</span>
            </div>
            <div class="header-right">
                <Button type="primary" size="small">保存表单</Button>
                <Icon 
                    type="ios-close-circle" 
                    size="24" 
                    color="#999" 
                    style="margin-left: 16px; cursor: pointer;"
                    @click="handleClose"
                />
            </div>
        </div>

        <!-- 主要内容区域 -->
        <div class="main-content">
            <!-- 左侧边栏 -->
            <div class="left-sidebar">
                <div class="sidebar-menu">
                    <div 
                        :class="{ active: currentTab === 'basic' }"
                        @click="currentTab = 'basic'"
                    >
                        基础设置
                    </div>
                    <div class="menu-group">
                        <div class="group-title" @click="toggleGroup('dynamic')">
                            <span>后续动态</span>
                            <Icon 
                                :type="isDynamicOpen ? 'ios-arrow-up' : 'ios-arrow-down'"
                                size="14"
                            />
                        </div>
                        <div v-if="isDynamicOpen" class="group-items">
                            <div 
                                :class="{ active: currentTab === 'list' }"
                                @click="currentTab = 'list'"
                            >
                                动态列表
                            </div>
                            <div 
                                :class="{ active: currentTab === 'settings' }"
                                @click="currentTab = 'settings'"
                            >
                                动态设置
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 右侧内容区 -->
            <div class="right-content">
                <!-- 基础设置 -->
                <div v-if="currentTab === 'basic'" class="tab-content">
                    <Form label-width="150" label-position="left">
                        <FormItem label="谁能填写">
                            <RadioGroup v-model="settings.whoCanFill">
                                <Radio label="all">所有人</Radio>
                                <Radio label="members">全部成员</Radio>
                                <Radio label="specified">指定成员</Radio>
                            </RadioGroup>
                            <p class="tip-text">
                                完全公开，任何人扫码都能操作，公开后表单记录所有人可见，请确保合法合规
                            </p>
                            <p class="tip-text red">所有人：无需登录，可填写</p>
                            <p class="tip-text red">
                                全部成员、指定成员：登录后，符合条件可填写
                            </p>
                            <Select
                                v-if="settings.whoCanFill === 'specified'"
                                placeholder="选择成员"
                                style="width: 200px; margin-top: 10px"
                            >
                                <Option value="user1">用户1</Option>
                            </Select>
                        </FormItem>

                        <FormItem label="每人可填写次数">
                            <RadioGroup v-model="settings.fillCountPerPerson">
                                <Radio label="unlimited">不限制</Radio>
                                <Radio label="once">每个二维码每人填写一次</Radio>
                                <Radio label="custom">自定义</Radio>
                            </RadioGroup>
                            <div v-if="settings.fillCountPerPerson === 'custom'" style="margin-top: 10px;">
                                <span>每个二维码每人每</span>
                                <InputNumber 
                                    v-model="settings.customDays" 
                                    :min="1" 
                                    style="width: 60px; margin: 0 8px;"
                                />
                                <span>天</span>
                                <span style="margin-left: 8px;">可填写</span>
                                <InputNumber 
                                    v-model="settings.customTimes" 
                                    :min="1" 
                                    style="width: 60px; margin: 0 8px;"
                                />
                                <span>次</span>
                            </div>
                        </FormItem>

                        <FormItem label="表单可填写总数">
                            <RadioGroup v-model="settings.totalFillCount">
                                <Radio label="unlimited">不限制</Radio>
                                <Radio label="limited">每个二维码该表单总共可填写</Radio>
                                <Radio label="custom">自定义</Radio>
                            </RadioGroup>
                            <div v-if="settings.totalFillCount !== 'unlimited'" style="margin-top: 10px;">
                                <InputNumber 
                                    v-model="settings.limitedCount" 
                                    :min="1" 
                                    style="width: 60px; margin-right: 8px;"
                                />
                                <span>次</span>
                            </div>
                            <div v-if="settings.totalFillCount === 'custom'" style="margin-top: 10px;">
                                <span>每个二维码该表单每</span>
                                <InputNumber 
                                    v-model="settings.customTotalDays" 
                                    :min="1" 
                                    style="width: 60px; margin: 0 8px;"
                                />
                                <span>天</span>
                                <span style="margin-left: 8px;">可填写</span>
                                <InputNumber 
                                    v-model="settings.customTotalTimes" 
                                    :min="1" 
                                    style="width: 60px; margin: 0 8px;"
                                />
                                <span>次</span>
                            </div>
                        </FormItem>

                        <FormItem label="可填写时间段">
                            <RadioGroup v-model="settings.timeRange">
                                <Radio label="unlimited">不限制</Radio>
                                <Radio label="custom">设置开始/停止时间</Radio>
                            </RadioGroup>
                            <div v-if="settings.timeRange === 'custom'" style="margin-top: 10px;">
                                <DatePicker 
                                    type="datetime" 
                                    placeholder="开始时间"
                                    style="width: 180px; margin-right: 10px;"
                                />
                                <span>~</span>
                                <DatePicker 
                                    type="datetime" 
                                    placeholder="结束时间"
                                    style="width: 180px; margin-left: 10px;"
                                />
                            </div>
                        </FormItem>
                    </Form>
                    <div class="ta-r mt24">
                        <Button type="primary">确定</Button>
                    </div>
                </div>

                <!-- 动态列表 -->
                <div v-if="currentTab === 'list'" class="tab-content">
                    <div class="filter-bar">
                        <Input 
                            placeholder="搜索评价内容或用户"
                            style="width: 200px; margin-right: 10px;"
                        />
                        <DatePicker 
                            type="daterange" 
                            placeholder="选择日期"
                            style="width: 200px; margin-right: 10px;"
                        />
                        <Button type="primary">确认搜索</Button>
                    </div>
                    
                    <Table 
                        :columns="listColumns" 
                        :data="listData" 
                        border
                        style="margin-top: 16px;"
                    >
                        <template slot-scope="{ row }" slot="action">
                            <Button 
                                type="success" 
                                ghost 
                                size="small"
                                @click="handleViewDetail(row)"
                            >
                                动态详情
                            </Button>
                        </template>
                    </Table>
                    
                    <div class="page-container">
                        <Page 
                            :current="pagination.page"
                            :total="pagination.total"
                            :page-size="pagination.pageSize"
                            show-elevator
                            show-total
                            @on-change="handlePageChange"
                        />
                    </div>
                </div>

                <!-- 动态设置 -->
                <div v-if="currentTab === 'settings'" class="tab-content">
                    <Form label-width="150" label-position="left">
                        <FormItem label="后续动态">
                            <i-switch 
                                v-model="dynamicSettings.enabled"
                                size="large"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                            <p class="tip-text">
                                在已提交的记录下追加说明、图片或表单，所有动态都沉淀在这条记录里
                            </p>
                        </FormItem>

                        <FormItem label="标题">
                            <Input 
                                v-model="dynamicSettings.title"
                                placeholder="请输入标题"
                                style="width: 250px;"
                            />
                            <span class="char-count">{{ dynamicSettings.title.length }}/10</span>
                        </FormItem>

                        <FormItem label="支持动态类型">
                            <CheckboxGroup v-model="dynamicSettings.types">
                                <Checkbox label="text">文字输入</Checkbox>
                                <div v-if="dynamicSettings.types.includes('text')" style="margin-top: 8px; margin-left: 24px;">
                                    <span style="margin-right: 8px;">输入框提示文案</span>
                                    <Input 
                                        v-model="dynamicSettings.textPlaceholder"
                                        placeholder="说明处理情况"
                                        style="width: 150px;"
                                    />
                                    <span class="char-count">{{ dynamicSettings.textPlaceholder.length }}/14</span>
                                </div>
                                <Checkbox label="photo">从相册上传照片</Checkbox>
                                <Checkbox label="camera">拍照</Checkbox>
                                <Checkbox label="form">填写表单</Checkbox>
                            </CheckboxGroup>
                            
                            <!-- 表单选择区域 -->
                            <div v-if="dynamicSettings.types.includes('form')" style="margin-top: 16px; margin-left: 24px;">
                                <div class="form-selector">
                                    <div class="form-selector-header">
                                        <span>选择账号下的表单</span>
                                        <Button type="text" style="color: #ff761d;">
                                            <Icon type="md-add" /> 创建表单
                                        </Button>
                                    </div>
                                    
                                    <!-- 未选择表单时显示 -->
                                    <div v-if="!selectedForm" class="form-list-placeholder">
                                        <Button type="text" style="color: #ff761d; width: 100%;">
                                            点击选择表单 <Icon type="ios-arrow-down" />
                                        </Button>
                                    </div>
                                    
                                    <!-- 已选择表单列表 -->
                                    <div v-else class="form-list">
                                        <div 
                                            v-for="(form, index) in selectedForms" 
                                            :key="index"
                                            class="form-item"
                                        >
                                            <div class="form-info">
                                                <div class="form-name">{{ form.name }} ({{ form.id }})</div>
                                                <div class="form-desc">{{ form.description }}</div>
                                                <div class="form-actions">
                                                    <Button type="text" size="small" style="color: #ff761d;">查看</Button>
                                                    <Button type="text" size="small" style="color: #ff761d;">选择</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!-- 已选中的单个表单详情 -->
                                    <div v-if="selectedSingleForm" class="form-detail-card">
                                        <div class="form-detail-header">
                                            <div>{{ selectedSingleForm.name }} ({{ selectedSingleForm.id }})</div>
                                        </div>
                                        <div class="form-detail-body">
                                            {{ selectedSingleForm.description }}
                                        </div>
                                        <div class="form-detail-footer">
                                            <Button type="primary" size="small">修改表单</Button>
                                            <Button type="default" size="small" style="margin-left: 8px;">表单规则</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FormItem>

                        <FormItem label="谁能回复">
                            <RadioGroup v-model="dynamicSettings.whoCanReply">
                                <Radio label="all">所有人</Radio>
                                <Radio label="specified">指定成员</Radio>
                            </RadioGroup>
                            <Select
                                v-if="dynamicSettings.whoCanReply === 'specified'"
                                placeholder="选择成员"
                                style="width: 200px; margin-top: 10px;"
                            >
                                <Option value="user1">用户1</Option>
                            </Select>
                        </FormItem>
                    </Form>
                </div>
            </div>
        </div>

        <!-- 动态详情弹窗 -->
        <Drawer
            v-model="detailDrawer.visible"
            title="动态详情"
            width="720"
            :mask-closable="false"
        >
            <div class="detail-drawer-content">
                <!-- 用户信息 -->
                <div class="detail-header">
                    <div class="user-info">
                        <span class="user-name">{{ detailDrawer.data.userName }}</span>
                        <span class="user-phone">{{ detailDrawer.data.userPhone }}</span>
                    </div>
                </div>

                <!-- 动态时间线 -->
                <div class="timeline">
                    <!-- 第一次提交 -->
                    <div class="timeline-item">
                        <div class="timeline-header">
                            <span class="timeline-user">{{ detailDrawer.data.userName }}</span>
                            <span class="timeline-time">{{ detailDrawer.data.firstSubmitTime }}</span>
                        </div>
                        <div class="timeline-content">
                            <p class="submit-label">第1次提交：表单</p>
                            <div class="content-box">
                                <p class="content-text">{{ detailDrawer.data.content }}</p>
                                <Button 
                                    type="text" 
                                    size="small" 
                                    style="color: #ff761d;"
                                    @click="toggleExpand"
                                >
                                    展开 <Icon :type="isExpanded ? 'ios-arrow-up' : 'ios-arrow-down'" />
                                </Button>
                            </div>
                        </div>
                    </div>

                    <!-- 回复人员 -->
                    <div class="timeline-item reply-item">
                        <div class="timeline-header">
                            <span class="reply-label">回复人员</span>
                            <span class="timeline-time">{{ detailDrawer.data.replyTime }}</span>
                        </div>
                        <div class="timeline-content">
                            <div class="reply-box">
                                <p>{{ detailDrawer.data.replyContent }}</p>
                            </div>
                        </div>
                    </div>

                    <!-- 第二次提交 -->
                    <div class="timeline-item">
                        <div class="timeline-header">
                            <span class="timeline-user">{{ detailDrawer.data.userName }}</span>
                            <span class="timeline-time">{{ detailDrawer.data.secondSubmitTime }}</span>
                        </div>
                        <div class="timeline-content">
                            <p class="submit-label">第2次提交：文本</p>
                            <div class="content-box">
                                <p class="content-text">{{ detailDrawer.data.secondContent }}</p>
                                <div class="photo-grid" v-if="detailDrawer.data.photos && detailDrawer.data.photos.length > 0">
                                    <div 
                                        v-for="(photo, index) in detailDrawer.data.photos" 
                                        :key="index"
                                        class="photo-item"
                                    >
                                        <img :src="photo" alt="现场照片" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 后台回复 -->
                <div class="reply-section">
                    <h3 class="section-title">后台回复</h3>
                    <Input 
                        v-model="replyText"
                        type="textarea"
                        :rows="4"
                        placeholder="请输入"
                    />
                    <div class="ta-r mt16">
                        <Button type="primary" @click="handleSubmitReply">发送回复</Button>
                    </div>
                </div>
            </div>
        </Drawer>
    </div>
</template>

<script>
export default {
    name: 'FormEvaluationDetail',
    data() {
        return {
            formName: '表单名称',
            currentTab: 'basic',
            isDynamicOpen: true,
            
            // 基础设置
            settings: {
                whoCanFill: 'all',
                fillCountPerPerson: 'unlimited',
                customDays: 1,
                customTimes: 1,
                totalFillCount: 'unlimited',
                limitedCount: 1,
                customTotalDays: 1,
                customTotalTimes: 1,
                timeRange: 'unlimited'
            },
            
            // 动态列表
            listColumns: [
                { type: 'index', width: 60, align: 'center', title: '#' },
                { title: '评价用户', key: 'userName', align: 'center' },
                { title: '手机号', key: 'phone', align: 'center' },
                { title: '提交时间', key: 'submitTime', align: 'center', width: '180px' },
                { title: '操作', slot: 'action', align: 'center', width: '120px' }
            ],
            listData: [],
            pagination: {
                page: 1,
                pageSize: 10,
                total: 100
            },
            
            // 动态设置
            dynamicSettings: {
                enabled: true,
                title: '后续动态',
                types: ['text', 'camera', 'form'],
                textPlaceholder: '说明处理情况',
                whoCanReply: 'specified'
            },
            selectedForm: false,
            selectedForms: [
                {
                    id: '123456',
                    name: '表单名称表单名称',
                    description: ''
                },
                {
                    id: '123456',
                    name: '表单名称表单名称',
                    description: ''
                },
                {
                    id: '123456',
                    name: '表单名称表单名称',
                    description: ''
                },
                {
                    id: '123456',
                    name: '表单名称表单名称',
                    description: ''
                }
            ],
            selectedSingleForm: null,
            
            // 详情抽屉
            detailDrawer: {
                visible: false,
                data: {}
            },
            isExpanded: false,
            replyText: ''
        };
    },
    mounted() {
        this.initMockData();
    },
    methods: {
        // 初始化模拟数据
        initMockData() {
            this.listData = Array.from({ length: 11 }, (_, i) => ({
                id: i + 1,
                userName: '周女士',
                phone: '138****2864',
                submitTime: '2021-5-16 18:21'
            }));
        },
        
        // 切换分组
        toggleGroup(group) {
            if (group === 'dynamic') {
                this.isDynamicOpen = !this.isDynamicOpen;
            }
        },
        
        // 查看详情
        handleViewDetail(row) {
            this.detailDrawer.data = {
                userName: row.userName,
                userPhone: row.phone,
                firstSubmitTime: '2026-12-12 12:12:12',
                content: '检查内容：箱体及箱内配件完好，无破损、变形或锈蚀无异响、异味、漏水无一闸多机、私拉乱接各指示灯状态正常各开关、断路器接触良好，无过热痕迹,电缆无破损，接头紧固可靠，接地系统连接良好',
                replyTime: '2026-12-12 12:12:12',
                replyContent: '感谢您的反馈！我们已收到本次提交内容，如有后续问题会及时跟进。',
                secondSubmitTime: '2026-12-12 12:12:12',
                secondContent: '补充反馈：现场图片上传后，希望能够更快显示预览效果。',
                photos: []
            };
            this.detailDrawer.visible = true;
            this.replyText = '';
        },
        
        // 切换展开
        toggleExpand() {
            this.isExpanded = !this.isExpanded;
        },
        
        // 提交回复
        handleSubmitReply() {
            if (!this.replyText.trim()) {
                this.$Message.warning('请输入回复内容');
                return;
            }
            this.$Message.success('回复成功');
            this.replyText = '';
        },
        
        // 分页变化
        handlePageChange(page) {
            this.pagination.page = page;
        },
        
        // 关闭页面
        handleClose() {
            this.$emit('close');
        }
    }
};
</script>

<style scoped>
.evaluation-detail-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #f5f6fa;
}

/* 顶部导航栏 */
.top-header {
    height: 60px;
    background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    z-index: 100;
}

.header-left .logo-text {
    font-size: 16px;
    font-weight: bold;
    color: #333;
}

.header-center .page-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
}

.header-right {
    display: flex;
    align-items: center;
}

/* 主要内容区域 */
.main-content {
    flex: 1;
    display: flex;
    overflow: hidden;
}

/* 左侧边栏 */
.left-sidebar {
    width: 200px;
    background: #fff;
    border-right: 1px solid #e8eaec;
    padding: 24px 0;
}

.sidebar-menu > div {
    padding: 12px 24px;
    cursor: pointer;
    color: #515a6e;
    transition: all 0.3s;
    font-size: 14px;
}

.sidebar-menu > div:hover {
    background: #f5f7fa;
}

.sidebar-menu > div.active {
    background: #fff7f0;
    color: #ff761d;
    border-left: 3px solid #ff761d;
    font-weight: bold;
}

.menu-group {
    margin-top: 8px;
}

.group-title {
    padding: 12px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    color: #515a6e;
    font-size: 14px;
}

.group-title:hover {
    background: #f5f7fa;
}

.group-items {
    background: #f9f9f9;
}

.group-items > div {
    padding: 12px 24px 12px 48px;
    cursor: pointer;
    color: #515a6e;
    font-size: 14px;
    transition: all 0.3s;
}

.group-items > div:hover {
    background: #f5f7fa;
}

.group-items > div.active {
    background: #fff7f0;
    color: #ff761d;
    font-weight: bold;
}

/* 右侧内容区 */
.right-content {
    flex: 1;
    background: #fff;
    overflow-y: auto;
    padding: 24px;
}

.tab-content {
    max-width: 800px;
}

.tip-text {
    font-size: 12px;
    color: #999;
    margin-top: 8px;
    line-height: 1.6;
}

.tip-text.red {
    color: #ed4014;
}

.ta-r {
    text-align: right;
}

.mt16 {
    margin-top: 16px;
}

.mt24 {
    margin-top: 24px;
}

/* 筛选栏 */
.filter-bar {
    display: flex;
    align-items: center;
    gap: 10px;
}

/* 字符计数 */
.char-count {
    font-size: 12px;
    color: #999;
    margin-left: 8px;
}

/* 表单选择器 */
.form-selector {
    border: 1px solid #dcdee2;
    border-radius: 4px;
    overflow: hidden;
}

.form-selector-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #f9f9f9;
    border-bottom: 1px solid #dcdee2;
    font-size: 14px;
}

.form-list-placeholder {
    padding: 12px 16px;
    text-align: center;
}

.form-list {
    max-height: 200px;
    overflow-y: auto;
}

.form-item {
    padding: 12px 16px;
    border-bottom: 1px solid #e8eaec;
}

.form-item:last-child {
    border-bottom: none;
}

.form-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.form-name {
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
}

.form-desc {
    font-size: 12px;
    color: #999;
}

.form-actions {
    display: flex;
    gap: 8px;
}

/* 表单详情卡片 */
.form-detail-card {
    border: 1px solid #dcdee2;
    border-radius: 4px;
    overflow: hidden;
}

.form-detail-header {
    padding: 12px 16px;
    background: #f9f9f9;
    border-bottom: 1px solid #dcdee2;
    font-size: 14px;
    color: #333;
}

.form-detail-body {
    padding: 12px 16px;
    font-size: 14px;
    color: #666;
    line-height: 1.6;
}

.form-detail-footer {
    padding: 12px 16px;
    border-top: 1px solid #dcdee2;
    display: flex;
    gap: 8px;
}

/* 详情抽屉内容 */
.detail-drawer-content {
    padding: 24px;
}

.detail-header {
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e8eaec;
}

.user-info {
    font-size: 16px;
    color: #333;
}

.user-name {
    font-weight: bold;
    margin-right: 8px;
}

.user-phone {
    color: #666;
}

/* 时间线 */
.timeline {
    position: relative;
    padding-left: 24px;
}

.timeline::before {
    content: '';
    position: absolute;
    left: 8px;
    top: 0;
    bottom: 0;
    width: 2px;
    background: #e8eaec;
}

.timeline-item {
    position: relative;
    margin-bottom: 32px;
}

.timeline-item::before {
    content: '';
    position: absolute;
    left: -20px;
    top: 4px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ff761d;
    border: 2px solid #fff;
    box-shadow: 0 0 0 2px #ff761d;
}

.timeline-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.timeline-user {
    font-size: 14px;
    font-weight: bold;
    color: #333;
}

.timeline-time {
    font-size: 12px;
    color: #999;
}

.submit-label {
    font-size: 12px;
    color: #666;
    margin-bottom: 8px;
}

.content-box {
    background: #f9f9f9;
    padding: 16px;
    border-radius: 4px;
    border: 1px solid #e8eaec;
}

.content-text {
    font-size: 14px;
    color: #333;
    line-height: 1.8;
    margin-bottom: 8px;
    text-indent: 2em;
}

/* 回复项特殊样式 */
.reply-item::before {
    background: #67c23a;
    box-shadow: 0 0 0 2px #67c23a;
}

.reply-label {
    font-size: 14px;
    font-weight: bold;
    color: #ff761d;
}

.reply-box {
    background: #f0f2f5;
    padding: 12px 16px;
    border-radius: 4px;
    font-size: 14px;
    color: #666;
    line-height: 1.6;
}

/* 照片网格 */
.photo-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    margin-top: 12px;
}

.photo-item {
    aspect-ratio: 1;
    background: #f0f2f5;
    border-radius: 4px;
    overflow: hidden;
}

.photo-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* 回复区域 */
.reply-section {
    margin-top: 32px;
    padding-top: 24px;
    border-top: 1px solid #e8eaec;
}

.section-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-bottom: 16px;
}

/* 表格样式优化 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    background: #f5f7fa !important;
    color: #484e66 !important;
    font-weight: bold;
}

::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}

::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}

/* 分页容器 */
.page-container {
    margin-top: 24px;
    text-align: right;
}

/* 滚动条样式 */
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 3px;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
}
</style>
